export interface MediaImage {
  node: {
    title?: string;
    altText?: string;
    sourceUrl?: string;
    mediaItemUrl?: string;
    mediaDetails?: {
      file: string;
      height: string | number;
      width: string | number;
      sizes: Array<InfoSizes>;
    };
  };
}

export interface InfoSizes {
  name: MediaSize & string;
  sourceUrl: string;
}

export enum MediaSize {
  LARGE = "large",
  MEDIUM_LARGE = "medium_large",
  MEDIUM = "medium",
  THUMBNAIL = "thumbnail",
}
